export default __webpack_public_path__ + "static/media/notesimg.66baf1ce.svg";